import {congrats} from "../data/congrats";
import Congrats from "./congrats.js";
import WheelFortune from "./wheel-fortune.js";

export default class Filter {
  constructor(siteBodyElement) {
    this._buttonFilterSelected = siteBodyElement.querySelector(`.page__filter-selected`);
    this._filterSelect = siteBodyElement.querySelector(`.page__filter-list`);
    this._congratsText = siteBodyElement.querySelector(`.congrats__text`);

    this._openFilter = this._openFilter.bind(this);
    this._closeFilter = this._closeFilter.bind(this);
    this._selectedFilter = this._selectedFilter.bind(this);
    this.congrats = new Congrats(siteBodyElement);
    this.wheelFortune = new WheelFortune(siteBodyElement);
    this.buttonStart = this.wheelFortune.startButton();
  }

  init() {
    this._buttonFilterSelected.addEventListener(`click`, this._openFilter);
    this._filterSelect.addEventListener(`click`, this._selectedFilter);
  }

  _openFilter(event) {
    event.preventDefault();
    this._buttonFilterSelected.classList.toggle(`filter_open`);
    console.log();
    this.buttonStart.style.zIndex = '1';
  }

  _closeFilter() {
    this._buttonFilterSelected.classList.remove(`filter_open`);
    this.buttonStart.style.zIndex = '13';
  }

  _selectedFilter(event) {
    event.preventDefault();
    ('ga' in window) && ga('send', 'event', 'SpecialProject', 'PodarkiNewYear2021');
    this._buttonFilterSelected.textContent = event.target.textContent;

    // console.log(event.target.dataset.filter);

    this._congratsText.textContent = congrats[event.target.dataset.filter].text;
    this._closeFilter();

    this.wheelFortune.state.filterItem = event.target.dataset.filter;

    if (!this.congrats._state.congratsActivate) {
      this.congrats.init();
    }
    this.congrats.shakeButtonShowCongrats();

    if (!this.wheelFortune.state.wheelButtonActivate) {
      this.wheelFortune.init();
    }
  }
}
